/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { TokenStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductCategory3Service = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/ProductCategory3",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, ProductCategory3) {
    var payload = ProductCategory3;
    var url = "api/ProductCategory3";

    if (mode == "create") {
       return await ApiService.post(
         url,
         payload,
         "String"
       );
    }
    else {    
      return await ApiService.patch(url, ProductCategory3.Code, payload, "String");
    }
  },
};

export { ProductCategory3Service };
